<template>
    <div>
        <!-- <div v-if="hideCondition && !buttonOnly" class="alert alert-primary">
            <div v-for="condition in promotion.conditions">
                <span v-if="promotion.condition_min_type == 'amount'">
                    {{ t("promotions.fill") }}
                    {{ condition.min_amount }}
                </span>
                <span v-else-if="promotion.condition_min_type == 'qty'">
                    {{ t("promotions.fill") }} {{ condition.min_qty }} {{ t("promotions.fillUnit") }}
                </span>
                <span v-if="promotion.discount_type == 'amount'">
                    {{ t("promotions.discounts") }}
                    {{ condition.discount_amount }}
                </span>
                <span v-else-if="promotion.discount_type == 'percentage'">
                    {{ t("promotions.discounts") }}
                    {{ condition.discount_percentage }} %
                </span>
                <span v-else-if="promotion.discount_type == 'gift'">
                    {{ t("promotions.freeGift") }}
                </span>
                <span v-else-if="promotion.discount_type == 'pricing'">
                    固定
                    {{ condition.discounted_price }}
                </span>
            </div>
        </div> -->

        <slot name="title" />

        <div v-if="promotion.ended_at && !buttonOnly" class="mt-3">
            <date-countdown :start-date="promotion.start_at" :end-date="promotion.ended_at" />
        </div>

        <div v-if="buttonOnly" class="d-flex p-1">
            <a v-if="!is_login" href="/login" title="登入" class="btn btn-lg btn-light mx-1"
                style="color: #eb1c74 !important;" :style="btnStyle" role="button" aria-disabled="true">
                <i class="navbar-tool-icon czi-user"></i>
            </a>

            <button v-if="!hiddenContact" :title="t('global.contactUs')" type="button" class="btn btn-lg btn-light mx-1" :style="btnStyle"
                role="button" aria-disabled="true" @click="redirectToFBMSN">
                <i class="navbar-tool-icon czi-message"></i>
            </button>

            <button v-if="!hiddenCart && !isEnded" :title="aliasTranslations?.add_to_cart || t('carts.addToCart')" type="button" class="btn btn-lg btn-secondary mx-1"
                :style="btnStyle" role="button" aria-disabled="true" @click="clickAddToCart">
                <el-badge v-if="count > 0" is-dot class="cart-badge">
                    <i class="navbar-tool-icon czi-cart"></i>
                </el-badge>
                <i v-else class="navbar-tool-icon czi-cart"></i>
            </button>

            <a v-if="isComing" :title="t('promotions.notYetStarted')" class="btn btn-lg btn-dark btn-block disabled mx-1"
                :style="btnStyle" role="button" aria-disabled="true">
                {{ t("promotions.notYetStarted") }}
            </a>
            <a v-else-if="!hiddenCart && !isEnded" :title="aliasTranslations?.buy_now || t('carts.buyNow')" class="btn btn-lg btn-primary btn-block mx-1"
                :style="btnStyle" role="button" aria-disabled="true" @click="clickBuyNow">
                {{ aliasTranslations?.buy_now || t("carts.buyNow") }}
            </a>
            
        </div>
        <div v-else class="d-none d-md-block">
            <button v-if="!hiddenCart && !isEnded" :title="aliasTranslations?.add_to_cart || t('carts.addToCart')" type="button" class="btn btn-lg btn-secondary btn-block"
                :style="btnStyle" role="button" aria-disabled="true" @click="clickAddToCart">
                {{ aliasTranslations?.add_to_cart || t("carts.addToCart") }}
            </button>

            <a v-if="isComing" class="btn btn-lg btn-dark btn-block disabled" :style="btnStyle" role="button"
                aria-disabled="true">
                {{ t("promotions.notYetStarted") }}
            </a>
            <a v-else-if="!hiddenCart && !isEnded" class="btn btn-lg btn-primary btn-block" :style="btnStyle" role="button"
                aria-disabled="true" @click="clickBuyNow">
                {{ aliasTranslations?.buy_now || t("carts.buyNow") }}
            </a>

            <button v-if="!hiddenContact" :title="t('global.contactUs')" type="button" class="btn btn-lg btn-light btn-block"
                style="border-color: #eaeaea;" :style="btnStyle" role="button" aria-disabled="true"
                @click="redirectToFBMSN">
                {{ t("global.contactUs") }}
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import DateCountdown from "./DateCountdown.vue"
import { dateFormat, notificationErrors, lookupAliasTranslations } from "../../utils"

const props = defineProps({
    promotion: Object,
    buttonOnly: Boolean,
    is_login: { type: Boolean, default: false },
    storeData: Object,
})
const emit = defineEmits(['buy-now', 'msg', 'add-to-cart'])

const { t, n, locale } = useI18n()

const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

const hideCondition = computed(() => (props.promotion?.condition_min_type == "non" || props.promotion?.discount_type == "non") ? false : true)
const isComing = computed(() => props.promotion?.start_at ? dayjs(props.promotion.start_at) > dayjs() : false)
const isEnded = computed(() => props.promotion?.ended_at ? dayjs(props.promotion.ended_at) < dayjs() : false)
const btnStyle = computed(() => props.buttonOnly ? {
    marginTop: '1px',
    borderRadius: '5px',
    height: '4rem',
    lineHeight: '2.5',
} : { marginTop: '0.5rem' })

const count = ref(0);

const scrollToBuyNowBlock = () => {
    const element = document.querySelector("a[name='buy-now-block']") || document.querySelector("#buy-now-block");
    if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        // 偵測 Lazyload 圖片導致沒正確滑到指定的位置（重做一次）
        const scrollIntoViewChecker = () => {
            const observer = new IntersectionObserver((entries) => {
                const entry = entries[0];
                if (!entry.isIntersecting) {
                    element.scrollIntoView({ behavior: "smooth" });
                    setTimeout(scrollIntoViewChecker, 1000);
                }
                observer.disconnect();
            }, { threshold: 0.1 });
            observer.observe(element);
        };
        setTimeout(scrollIntoViewChecker, 1000);
    }
}

const clickBuyNow = () => {
    // if (!props.is_login) {
    //     notificationErrors({'errors': [{'type': 'RequireLoginError', 'msg': '請先登入會員'}]})
    // } else {
    //     emit("buy-now")
    // }
    emit("buy-now")
    scrollToBuyNowBlock();
}
const redirectToFBMSN = () => {
    emit("msg")
}
const clickAddToCart = () => {
    emit("add-to-cart")
    scrollToBuyNowBlock();
}

onMounted(() => {
    count.value = localStorage.getItem('CART_COUNT') || 0
    window.addEventListener('CART_COUNT-localstorage-changed', (event) => {
        count.value = event.detail.storage;
        // console.log("CART_COUNT-b: ", event.detail.storage)
    });
})
</script>
<style>
.cart-badge .is-dot {
    top: .5rem !important;
    right: 0rem !important;
}
</style>